import 'date-input-polyfill/date-input-polyfill.dist.js'; //polyfill for input type "date";
import { Navigation } from 'Components/navigation';
import { SectionNav } from 'Components/sectionNav';
import { Tooltips } from 'Modules/tooltips';
import { Alerts } from 'Modules/alerts';
import { FlexFont } from 'Modules/flexFont';
import { ScrollEffects } from 'Components/scrollEffects';
import { Tabs } from 'Components/tabs';
import { ImageVideoCarousel } from 'Components/imageVideoCarousel';
import { Modals } from 'Components/modals';
import { StackRotator } from 'Components/stackRotator';
import * as balanceText from 'Lib/balanceText.js';
import { WishlistDisplay } from 'Modules/wishlistDisplay';
import { WishlistToggle } from 'Modules/wishlistToggle';
import { throttle } from 'throttle-debounce';
//@ts-ignore
import { createApp, App } from 'vue';
import Search from 'Vue/components/search/Search.vue';

export namespace Global {
    let calculateScrollBarPostion = () => {
        let check = () => {
            let $el = $('<div style="width: 100%"></div>');
            $el.appendTo('body');
            let constrainedWidth = $el.width();

            $el.css('width', '100vw');
            let fullWidth = $el.width();
            let scrollbarWidth = Math.ceil(fullWidth - constrainedWidth);

            document.documentElement.style.setProperty('--scrollbar-width', scrollbarWidth + 'px');
            $el.remove();
        };

        check();
        window.addEventListener(
            'resize',
            throttle(600, false, () => {
                check();
            })
        );

        window.addEventListener('orientationchange', () => {
            check();
        });
    };

    let initializeBalanceText = () => {
        balanceText();
    };

    let initializeSearch = () => {
        //silently fail vue initialization if we dont have the proper initialization div
        if (!document.getElementById('siteQuickSearch')) {
            return;
        }

        const quickSearchApp: App = createApp(Search);
        quickSearchApp.mount('#siteQuickSearch');
    };

    let setTouchOrNoTouch = () => {
        let isTouchDevice = () => {
            return window.matchMedia('(pointer: coarse)').matches;
        };

        if (isTouchDevice()) {
            document.body.classList.add('touch');
            document.body.classList.remove('no-touch');
        } else {
            document.body.classList.remove('touch');
            document.body.classList.add('no-touch');
        }
    };

    // let smoothScrollToLinks = () => {
    // 	let pageLinks = document.querySelectorAll('a[href^="#"]');
    //
    // 	if(!pageLinks.length) {
    // 		return
    // 	}
    //
    // 	pageLinks.forEach((link) => {
    // 		window.scroll({
    // 			top: 2500,
    // 			left: 0,
    // 			behavior: 'smooth'
    // 		});
    // 	});
    // }

    //in the backend of sitefinity there is a tray you can close and open for content and layout this determines if it is open or not and adds a class on the body if its open
    //this is useful for configuring styles only for the backend when opened and closed.
    let watchSitefinityBackendTray = () => {
        if (!document.body.classList.contains('sfPageEditor')) {
            return;
        }

        let elementToObserve = null;

        let observeTheElement = () => {
            elementToObserve = document.getElementById('sfHideShowToolbox');
            let checkClassAttribute = (mutation?) => {
                let el = mutation ? mutation.target : elementToObserve;
                if (el.classList.contains('sfHiddenToolbox')) {
                    document.body.classList.remove('sfEditorToolboxOpen');
                    document.body.classList.add('sfEditorToolboxClosed');
                } else {
                    document.body.classList.remove('sfEditorToolboxClosed');
                    document.body.classList.add('sfEditorToolboxOpen');
                }
            };
            checkClassAttribute();

            let callback = (mutationList, observer) => {
                mutationList.forEach(function (mutation) {
                    switch (mutation.type) {
                        case 'attributes':
                            switch (mutation.attributeName) {
                                case 'class':
                                    checkClassAttribute(mutation);
                                    break;
                            }
                            break;
                    }
                });
            };
            const observer = new MutationObserver(callback);
            observer.observe(elementToObserve, {
                subtree: true,
                attributeFilter: ['class'],
                attributeOldValue: true,
            });
        };

        if (!elementToObserve) {
            //The node we need does not exist yet.
            //Wait 500ms and try again
            window.setTimeout(observeTheElement, 200);
            return;
        } else {
            observeTheElement();
        }
    };

    //accessibility function, add tabindex -1 to remove from tabindex on subnavigation menus
    let subNavSkipTabbing = () => {
        let subNavs = document.querySelectorAll('.js-sub-nav');

        subNavs.forEach((subnav) => {
            let links = subnav.querySelectorAll('a');
            links.forEach((link) => {
                link.setAttribute('tabindex', '-1');
            });
        });
    };

    let linkTargetCheck = () => {
        let link = document.getElementsByTagName('a');

        if (link.length) {
            for (let i = 0; link.length > i; i++) {
                let currentLink = link[i];

                if (
                    (currentLink.hostname !== location.hostname && !currentLink.classList.contains('internal-link')) ||
                    currentLink.pathname.includes('.pdf') ||
                    currentLink.pathname.includes('.doc') ||
                    currentLink.pathname.includes('.docx') ||
                    currentLink.pathname.includes('.xlsx')
                ) {
                    currentLink.setAttribute('target', '_blank');
                }
            }
        }
    };

    /**
     * Container Initialization
     */
    export const init = () => {
        linkTargetCheck();
        setTouchOrNoTouch();
        Alerts.init();
        subNavSkipTabbing();
        initializeSearch();
        calculateScrollBarPostion();
        watchSitefinityBackendTray();
        Navigation.init();
        SectionNav.init();
        ImageVideoCarousel.init();
        Modals.init();
        ScrollEffects.init();
        Tabs.init();
        FlexFont.init();
        Tooltips.init();
        StackRotator.init();
        initializeBalanceText();
        WishlistDisplay.init();
        WishlistToggle.init();
    };
}

Global.init();
